import Vue from 'vue'
import VueIdb from 'vue-idb'

Vue.use(VueIdb)

export default new VueIdb({
  version: 3,
  database: 'arbopasto',
  schemas: [
    { tree: 'code, common_name, cached, getted' }
  ]
})



// WEBPACK FOOTER //
// ./src/db.js